export default __webpack_public_path__ + "static/media/kwh-color.306ff84a.svg";